export const LOGIN_ASIDE_ITEMS = [
  {
    TITLE: `New to SageSure Agent Portal?`,
    MESSAGE: `The SageSure AgentPortal provides access to SageSure's Products, allowing registered Agents to create quotes and bind and manage their customers' policies.`,
    URL: "https://www.sagesure.com/about/",
    TARGET: "_blank",
    ICON: "Computer"
  },
  {
    TITLE: `Your Privacy is Protected`,
    MESSAGE: `SageSure maintains administrative policies and technical safeguards that are designed to protect your information against loss or unauthorized access or acquisition.`,
    URL: "https://www.sagesure.com/privacy-policy/",
    TARGET: "_blank",
    ICON: "Eyeball"
  },
  {
    TITLE: `Your Problems Are Our Problems`,
    MESSAGE: `Our Policy Services Team is here to help you with any technical, quote, policy, claims, or underwriting-related matters.`,
    URL: "https://www.sagesure.com/support/",
    TARGET: "_blank",
    ICON: "Phone"
  }
];
